/* eslint-disable no-new */
import FlickityImagesLoaded from 'flickity-imagesloaded';
import throttle from 'lodash/throttle';

const carousels = Array.from(document.querySelectorAll('.js-carousel'));

const fullHeightCells = (carousel) => {
    const cards = Array.from(carousel.querySelectorAll('.flickity-slider > *'));
    cards.forEach((card) => {
        card.classList.remove('min-h-full');
        card.classList.add('min-h-full');
    });
};

const largeScreen = () => matchMedia('screen and (min-width: 1024px);').matches;

const mount = (carousel) => {
    const stretchCells = carousel.classList.contains('js-cells-full-height');
    new FlickityImagesLoaded(carousel, {
        prevNextButtons: false,
        lazyLoad: 2,
        imagesLoaded: true,
        adaptiveHeight: !stretchCells,
        cellAlign: largeScreen() ? 'left' : 'center',
        accessibility: false,
        watchCSS: !!carousel.dataset.responsive
    });
    if (stretchCells) fullHeightCells(carousel);
};

carousels.forEach((carousel) => {
    mount(carousel);
    window.addEventListener(
        'resize',
        throttle(() => mount(carousel), 2000)
    );
});
